import Popper from '@components/Popper';
import { StyledMenuHeader, ScrollableSection } from './styles';
import { DesktopMenuItem } from '.';

const Submenu = ({ anchorEl, menu }) => {
    return (
        anchorEl && (
            <Popper
                anchorEl={anchorEl}
                open={!!anchorEl}
                popperOptions={{
                    placement: 'right',
                }}
            >
                <StyledMenuHeader>{menu.header}</StyledMenuHeader>
                <ScrollableSection disablePadding>
                    {menu?.list?.map(item => (
                        <DesktopMenuItem key={item.text} item={item} anchorEl={anchorEl} />
                    ))}
                </ScrollableSection>
            </Popper>
        )
    );
};

export default Submenu;
